const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogSolicitacaoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogSolicitacaoFormacao`, params);
    },
    $obterRelatorioLogCSVSolicitacaoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeSolicitacaoFormacaoCsv`, params);
    },
    $obterRelatorioLogPDFSolicitacaoFormacao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeSolicitacaoFormacaoPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;